import React from 'react'
import propTypes from 'prop-types'
import GooglePlayIcon from 'assets/image/retail-landing-page/google-play-icon.png'

const GooglePlay = ({ className, ...props }) => (
  <a
    href="https://play.google.com/store/apps/details?id=com.tjetak.distribution"
    target="_blank"
    className={`cursor-pointer mt-[40px] lg:mt-[48px] xl:mt-[48px] h-[60px] w-[189px] md:h-[72px] md:w-[206px] border border-white font-medium rounded-lg text-white flex justify-center items-center ${className}`}
    rel="noreferrer"
    {...props}
  >
    <div className="flex items-center justify-center gap-2">
      <img className="h-[30px] object-contain mr-[12px]" src={GooglePlayIcon} />
      <div>
        <p className="text-[10px] m-0">GET IT ON</p>
        <p className="text-[18px] font-[500] m-0">Google Play</p>
      </div>
    </div>
  </a>
)

GooglePlay.propTypes = {
  className: propTypes.string
}

export default GooglePlay
